var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticStyle:{"width":"1024px","margin":"auto"}},[_c('div',{},[(_vm.loading)?_c('circle4'):_vm._e(),_vm._v(" "),_c('div',{staticClass:"spacer sm"}),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.content[1])}}),_vm._v(" "),(_vm.benchlang === 'de')?_c('h2',[_vm._v("1. FÜHRUNG")]):_vm._e(),_vm._v(" "),(_vm.benchlang === 'it')?_c('h2',[_vm._v("1. DIRIGENZA")]):_vm._e(),_vm._v(" "),(_vm.benchlang === 'de')?_c('h5',[_vm._v("Verhältnis Brutto- / Nettostunden Mitarbeiter in Prozent (Anteil Ist-Stunden auf Sollstunden der Mitarbeiter)")]):_vm._e(),_vm._v(" "),(_vm.benchlang === 'it')?_c('h5',[_vm._v("Ore prestate dai collaboratori: lordo/netto (media)")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"spacer sm"}),_vm._v(" "),(_vm.benchlang === 'de')?_c('stats',{attrs:{"chart-data":{
                    labels: [],
                    datasets: [
                      {
                        label: 'Kleine Strukturen',
                        backgroundColor: '#FFC002',
                        data: [_vm.klein[1].total / _vm.klein[1].arr.length]
                      },
                      {
                        label: 'Mittlere Strukturen',
                        backgroundColor: '#9BBB59',
                        data: [_vm.mittel[1].total / _vm.mittel[1].arr.length]
                      },
                      {
                        label: 'Grosse Strukturen',
                        backgroundColor: '#77933C',
                        data: [_vm.gross[1].total / _vm.gross[1].arr.length]
                      },
                      {
                        label: 'Durchschnitt',
                        backgroundColor: '#376092',
                        data: [((_vm.klein[1].total / _vm.klein[1].arr.length)+(_vm.mittel[1].total / _vm.mittel[1].arr.length)+(_vm.gross[1].total / _vm.gross[1].arr.length))/3]
                      }
                    ]
                  },"options":{responsive: true, maintainAspectRatio: true, legend: {display: true, position: 'right'}, plugins: { datalabels: { color: '#000', font: { weight: 'bold' }, anchor: 'end', align: 'end' }}, scales: { yAxes: [{ ticks: { beginAtZero:true }}] }, title: { display: false, text: 'Verhältnis Brutto- / Nettostunden Mitarbeiter in Prozent (Anteil Ist-Stunden auf Sollstunden der Mitarbeiter)', fontColor: '#000', fontSize: '18', padding: 40 }},"width":"2048","height":"800"}}):_vm._e(),_vm._v(" "),(_vm.benchlang === 'it')?_c('stats',{attrs:{"chart-data":{
                    labels: [''],
                    datasets: [
                      {
                        label: 'Strutture piccole',
                        backgroundColor: '#FFC002',
                        data: [_vm.klein[1].total / _vm.klein[1].arr.length]
                      },
                      {
                        label: 'Strutture medie',
                        backgroundColor: '#9BBB59',
                        data: [_vm.mittel[1].total / _vm.mittel[1].arr.length]
                      },
                      {
                        label: 'Strutture Grandi',
                        backgroundColor: '#77933C',
                        data: [_vm.gross[1].total / _vm.gross[1].arr.length]
                      },
                      {
                        label: 'Media',
                        backgroundColor: '#376092',
                        data: [((_vm.klein[1].total / _vm.klein[1].arr.length)+(_vm.mittel[1].total / _vm.mittel[1].arr.length)+(_vm.gross[1].total / _vm.gross[1].arr.length))/3]
                      }
                    ]
                  },"options":{responsive: true, maintainAspectRatio: false, legend: {display: true, position: 'right'}, plugins: { datalabels: { color: '#000', font: { weight: 'bold' }, anchor: 'end', align: 'end' }}, scales: { yAxes: [{ ticks: { beginAtZero:true }}] }, title: { display: false, text: 'Ore prestate dai collaboratori: lordo/netto (media)', padding: 40 }}}}):_vm._e(),_vm._v(" "),_c('button',{attrs:{"type":"button"},on:{"click":_vm.downcanvas}},[_vm._v("download")]),_vm._v(" "),_c('a',{attrs:{"download":"myImage.jpg","href":""},on:{"click":function($event){_vm.downcanvas(this)}}},[_vm._v("Download to myImage.jpg")]),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.content[2])}}),_vm._v(" "),(_vm.benchlang === 'de')?_c('h2',[_vm._v("2. POLITIK UND STRATEGIE")]):_vm._e(),_vm._v(" "),(_vm.benchlang === 'it')?_c('h2',[_vm._v("2. POLITICA E STRATEGIA")]):_vm._e(),_vm._v(" "),(_vm.benchlang === 'de')?_c('h5',[_vm._v("Auslastung in den RQA-Heimen (Mittelwerte in Prozent)")]):_vm._e(),_vm._v(" "),(_vm.benchlang === 'it')?_c('h5',[_vm._v("Copertura posti letto nelle residenze RQA (media)")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"spacer sm"}),_vm._v(" "),(_vm.benchlang === 'de')?_c('stats',{attrs:{"chart-data":{
                    labels: ['Bettenauslastung Daueraufnahme', 'Bettenauslastung Kurzzeitpflege', 'Auslastung Tagespflege', 'Auslastung des Tagespflegeheims'],
                    datasets: [
                      {
                        label: 'Kleine Strukturen',
                        backgroundColor: '#FFC002',
                        data: [_vm.klein[2].total / _vm.klein[2].arr.length, _vm.klein[3].total / _vm.klein[3].arr.length, _vm.klein[4].total / _vm.klein[4].arr.length ]
                      },
                      {
                        label: 'Mittlere Strukturen',
                        backgroundColor: '#9BBB59',
                        data: [_vm.mittel[2].total / _vm.mittel[2].arr.length, _vm.mittel[3].total / _vm.mittel[3].arr.length, _vm.mittel[4].total / _vm.mittel[4].arr.length ]
                      },
                      {
                        label: 'Grosse Strukturen',
                        backgroundColor: '#77933C',
                        data: [_vm.gross[2].total / _vm.gross[2].arr.length, _vm.gross[3].total / _vm.gross[3].arr.length, _vm.gross[4].total / _vm.gross[4].arr.length ]
                      },
                      {
                        label: 'Durchschnitt',
                        backgroundColor: '#376092',
                        data: [((_vm.klein[2].total / _vm.klein[2].arr.length)+(_vm.mittel[2].total / _vm.mittel[2].arr.length)+(_vm.gross[2].total / _vm.gross[2].arr.length))/3, ((_vm.klein[3].total / _vm.klein[3].arr.length)+(_vm.mittel[3].total / _vm.mittel[3].arr.length)+(_vm.gross[3].total / _vm.gross[3].arr.length))/3, ((_vm.klein[4].total / _vm.klein[4].arr.length)+(_vm.mittel[4].total / _vm.mittel[4].arr.length)+(_vm.gross[4].total / _vm.gross[4].arr.length))/3, _vm.overall[5].total / _vm.overall[5].arr.length]
                      }
                    ]
                  },"options":{responsive: true, maintainAspectRatio: false, legend: { display: true, position: 'right'}, plugins: { datalabels: { color: '#000', font: { weight: 'bold' }, formatter: function(value) {if(isNaN(value)){return '' } return value.toFixed(2) }, anchor: 'end', align: 'end' } }, scales: { yAxes: [{ ticks: { beginAtZero:true, max: 120 } }] }, title: { display: false, text: 'Auslastung in den RQA-Heimen (Mittelwerte)', padding: 40
        }}}}):_vm._e(),_vm._v(" "),(_vm.benchlang === 'it')?_c('stats',{attrs:{"chart-data":{
                    labels: ['Ricovero permanente', 'Ricovero temporaneo', 'Assistenza diurna', 'Assistenza diurna'],
                    datasets: [
                      {
                        label: 'Strutture piccole',
                        backgroundColor: '#FFC002',
                        data: [_vm.klein[2].total / _vm.klein[2].arr.length, _vm.klein[3].total / _vm.klein[3].arr.length, _vm.klein[4].total / _vm.klein[4].arr.length ]
                      },
                      {
                        label: 'Strutture medie',
                        backgroundColor: '#9BBB59',
                        data: [_vm.mittel[2].total / _vm.mittel[2].arr.length, _vm.mittel[3].total / _vm.mittel[3].arr.length, _vm.mittel[4].total / _vm.mittel[4].arr.length ]
                      },
                      {
                        label: 'Strutture grandi',
                        backgroundColor: '#77933C',
                        data: [_vm.gross[2].total / _vm.gross[2].arr.length, _vm.gross[3].total / _vm.gross[3].arr.length, _vm.gross[4].total / _vm.gross[4].arr.length ]
                      },
                      {
                        label: 'Media',
                        backgroundColor: '#376092',
                        data: [((_vm.klein[2].total / _vm.klein[2].arr.length)+(_vm.mittel[2].total / _vm.mittel[2].arr.length)+(_vm.gross[2].total / _vm.gross[2].arr.length))/3, ((_vm.klein[3].total / _vm.klein[3].arr.length)+(_vm.mittel[3].total / _vm.mittel[3].arr.length)+(_vm.gross[3].total / _vm.gross[3].arr.length))/3, ((_vm.klein[4].total / _vm.klein[4].arr.length)+(_vm.mittel[4].total / _vm.mittel[4].arr.length)+(_vm.gross[4].total / _vm.gross[4].arr.length))/3, _vm.overall[5].total / _vm.overall[5].arr.length]
                      }
                    ]
                  },"options":{responsive: true, maintainAspectRatio: false, legend: { display: true, position: 'right'}, plugins: { datalabels: { color: '#000', font: { weight: 'bold' }, formatter: function(value) {if(isNaN(value)){return '' } return value.toFixed(2) }, anchor: 'end', align: 'end' } }, scales: { yAxes: [{ ticks: { beginAtZero:true, max: 120 } }] }, title: { display: false, text: 'Auslastung in den RQA-Heimen (Mittelwerte)', padding: 40
        }}}}):_vm._e(),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.content[3])}}),_vm._v(" "),(_vm.benchlang === 'de')?_c('h2',[_vm._v("3. MITARBEITER")]):_vm._e(),_vm._v(" "),(_vm.benchlang === 'it')?_c('h2',[_vm._v("3. COLLABORATORI")]):_vm._e(),_vm._v(" "),(_vm.benchlang === 'de')?_c('h5',[_vm._v("Mitarbeiter in Teilzeit- / Vollzeitarbeitsverhältnis (Mittelwerte in Prozent und Anzahl)")]):_vm._e(),_vm._v(" "),(_vm.benchlang === 'it')?_c('h5',[_vm._v("Collaboratori con rapporto di lavoro a tempo parziale / tempo pieno (media)")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"grid",staticStyle:{"grid-template-columns":"1fr 1fr 1fr"}},[(_vm.benchlang === 'de')?_c('pie',{attrs:{"chart-data":{
      labels: [
      'Teilzeit', 'Vollzeit'
      ],
      datasets: [
        {
          backgroundColor: [
            '#FFC002',
            '#9BBB59'
          ],
          labels: '%',
          data: [(_vm.klein[6].total / _vm.klein[6].arr.length), (_vm.klein[7].total / _vm.klein[7].arr.length)]
        },
        {
          backgroundColor: [
            '#FFC002',
            '#9BBB59'
          ],
          labels: 'MA',
          data: [(_vm.klein[6].totval / _vm.klein[6].val.length), (_vm.klein[7].totval / _vm.klein[7].val.length)]
        }
      ]
    },"options":{responsive: false, maintainAspectRatio: false, legend: { display: true, position: 'bottom', reverse: true}, plugins: { datalabels: { color: '#000', font: { weight: 'bold' }, formatter: function(value, context) {
    return value.toFixed(2) + ' ' + context.chart.data.datasets[context.datasetIndex].labels}}}, title: { display: true, position: 'top', text: 'Kleine Strukturen'}},"width":"341px","height":"341px"}}):_vm._e(),_vm._v(" "),(_vm.benchlang === 'de')?_c('pie',{attrs:{"chart-data":{
      labels: [
      'Teilzeit', 'Vollzeit'
      ],
      datasets: [
        {
          backgroundColor: [
            '#FFC002',
            '#9BBB59'
          ],
          labels: '%',
          data: [(_vm.mittel[6].total / _vm.mittel[6].arr.length), (_vm.mittel[7].total / _vm.mittel[7].arr.length)]
        },
        {
          backgroundColor: [
            '#FFC002',
            '#9BBB59'
          ],
          labels: 'MA',
          data: [(_vm.mittel[6].totval / _vm.mittel[6].val.length), (_vm.mittel[7].totval / _vm.mittel[7].val.length)]
        }
      ]
    },"options":{responsive: false, maintainAspectRatio: false, legend: { display: true, position: 'bottom', reverse: true}, plugins: { datalabels: { color: '#000', font: { weight: 'bold' }, formatter: function(value, context) {
    return Math.round(value * 100) / 100 + ' ' + context.chart.data.datasets[context.datasetIndex].labels}}}, title: { display: true, position: 'top', text: 'Mittlere Strukturen'}},"width":"341px","height":"341px"}}):_vm._e(),_vm._v(" "),(_vm.benchlang === 'de')?_c('pie',{attrs:{"chart-data":{
      labels: [
      'Teilzeit', 'Vollzeit'
      ],
      datasets: [
        {
          backgroundColor: [
            '#FFC002',
            '#9BBB59'
          ],
          labels: '%',
          data: [(_vm.gross[6].total / _vm.gross[6].arr.length), (_vm.gross[7].total / _vm.gross[7].arr.length)],
          cal: [(_vm.gross[6].total / _vm.gross[6].arr.length), (_vm.gross[7].total / _vm.gross[7].arr.length)]
        },
        {
          backgroundColor: [
            '#FFC002',
            '#9BBB59'
          ],
          labels: 'MA',
          cal: [(_vm.gross[6].totval / _vm.gross[6].val.length), (_vm.gross[7].totval / _vm.gross[7].val.length)],
          data: [(_vm.gross[6].total / _vm.gross[6].arr.length), (_vm.gross[7].total / _vm.gross[7].arr.length)]
        }
      ]
    },"options":{responsive: false, maintainAspectRatio: false, legend: { display: true, position: 'bottom', reverse: true}, plugins: { datalabels: { color: '#000', font: { weight: 'bold' }, formatter: function(value, context) {
    return context.chart.data.datasets[context.datasetIndex].cal[context.dataIndex] + ' ' + context.chart.data.datasets[context.datasetIndex].labels}}}, title: { display: true, position: 'top', text: 'Grosse Strukturen'}},"width":"341px","height":"341px"}}):_vm._e(),_vm._v(" "),(_vm.benchlang === 'it')?_c('pie',{attrs:{"chart-data":{
      labels: [
      'Part-Time', 'Tempo pieno'
      ],
      datasets: [
        {
          backgroundColor: [
            '#FFC002',
            '#9BBB59'
          ],
          labels: '%',
          data: [(_vm.klein[6].total / _vm.klein[6].arr.length), (_vm.klein[7].total / _vm.klein[7].arr.length)]
        },
        {
          backgroundColor: [
            '#FFC002',
            '#9BBB59'
          ],
          labels: 'MA',
          data: [(_vm.klein[6].totval / _vm.klein[6].val.length), (_vm.klein[7].totval / _vm.klein[7].val.length)]
        }
      ]
    },"options":{responsive: false, maintainAspectRatio: true, legend: { display: true, position: 'bottom', reverse: true}, plugins: { datalabels: { color: '#000', font: { weight: 'bold' }, formatter: function(value, context) {
    return value.toFixed(2) + ' ' + context.chart.data.datasets[context.datasetIndex].labels}}}, title: { display: true, position: 'top', text: 'Strutture piccole'}},"width":"341px","height":"341px"}}):_vm._e(),_vm._v(" "),(_vm.benchlang === 'it')?_c('pie',{attrs:{"chart-data":{
      labels: [
      'Part-Time', 'Tempo pieno'
      ],
      datasets: [
        {
          backgroundColor: [
            '#FFC002',
            '#9BBB59'
          ],
          labels: '%',
          data: [(_vm.mittel[6].total / _vm.mittel[6].arr.length), (_vm.mittel[7].total / _vm.mittel[7].arr.length)]
        },
        {
          backgroundColor: [
            '#FFC002',
            '#9BBB59'
          ],
          labels: 'MA',
          data: [(_vm.mittel[6].totval / _vm.mittel[6].val.length), (_vm.mittel[7].totval / _vm.mittel[7].val.length)]
        }
      ]
    },"options":{responsive: false, maintainAspectRatio: true, legend: { display: true, position: 'bottom', reverse: true}, plugins: { datalabels: { color: '#000', font: { weight: 'bold' }, formatter: function(value, context) {
    return Math.round(value * 100) / 100 + ' ' + context.chart.data.datasets[context.datasetIndex].labels}}}, title: { display: true, position: 'top', text: 'Strutture medie'}},"width":"341px","height":"341px"}}):_vm._e(),_vm._v(" "),(_vm.benchlang === 'it')?_c('pie',{attrs:{"chart-data":{
      labels: [
      'Part-Time', 'Tempo pieno'
      ],
      datasets: [
        {
          backgroundColor: [
            '#FFC002',
            '#9BBB59'
          ],
          labels: '%',
          data: [(_vm.gross[6].total / _vm.gross[6].arr.length), (_vm.gross[7].total / _vm.gross[7].arr.length)],
          cal: [(_vm.gross[6].total / _vm.gross[6].arr.length), (_vm.gross[7].total / _vm.gross[7].arr.length)]
        },
        {
          backgroundColor: [
            '#FFC002',
            '#9BBB59'
          ],
          labels: 'MA',
          cal: [(_vm.gross[6].totval / _vm.gross[6].val.length), (_vm.gross[7].totval / _vm.gross[7].val.length)],
          data: [(_vm.gross[6].total / _vm.gross[6].arr.length), (_vm.gross[7].total / _vm.gross[7].arr.length)]
        }
      ]
    },"options":{responsive: false, maintainAspectRatio: true, legend: { display: true, position: 'bottom', reverse: true}, plugins: { datalabels: { color: '#000', font: { weight: 'bold' }, formatter: function(value, context) {
    return context.chart.data.datasets[context.datasetIndex].cal[context.dataIndex] + ' ' + context.chart.data.datasets[context.datasetIndex].labels}}}, title: { display: true, position: 'top', text: 'Strutture grandi'}},"width":"341px","height":"341px"}}):_vm._e()],1),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.content[4])}}),_vm._v(" "),(_vm.benchlang === 'de')?_c('h5',[_vm._v("Bereich Pflege/Betreuung/REHA: Mitarbeiter Altersstufen (Mittelwerte in Prozent)")]):_vm._e(),_vm._v(" "),(_vm.benchlang === 'it')?_c('h5',[_vm._v("Settore cura/assistenza/riabilitazione: fasce d’età dei collaboratori (media)")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"grid",staticStyle:{"grid-template-columns":"1fr 1fr"}},[(_vm.benchlang === 'de')?_c('pie',{attrs:{"chart-data":{
      labels: ['bis 30 Jahre alt', '31-40 Jahre alt', '41-50 Jahre alt', '51-60 Jahre alt', 'über 61 Jahre alt'],
      datasets: [
        {
          backgroundColor: [
            '#FFC002',
            '#FF9901',
            '#9BBB59',
            '#77933C',
            '#376092'
          ],
          labels: '',
          data: [(_vm.klein[8].total / _vm.klein[8].arr.length), (_vm.klein[9].total / _vm.klein[9].arr.length), (_vm.klein[10].total / _vm.klein[10].arr.length), (_vm.klein[11].total / _vm.klein[11].arr.length), (_vm.klein[12].total / _vm.klein[12].arr.length)]
        }
      ]
    },"options":{responsive: true, maintainAspectRatio: false, legend: { display: false, position: 'right'}, plugins: { datalabels: { color: '#000', formatter: function(value, context) {
    return value.toFixed(2) + ' ' + context.chart.data.datasets[context.datasetIndex].labels}, font: { weight: 'bold' }}}, title: { display: true, text: 'Kleine Strukturen'
        }}}}):_vm._e(),_vm._v(" "),(_vm.benchlang === 'de')?_c('pie',{attrs:{"chart-data":{
      labels: ['bis 30 Jahre alt', '31-40 Jahre alt', '41-50 Jahre alt', '51-60 Jahre alt', 'über 61 Jahre alt'],
      datasets: [
        {
          backgroundColor: [
            '#FFC002',
            '#FF9901',
            '#9BBB59',
            '#77933C',
            '#376092'
          ],
          labels: '',
          data: [(_vm.mittel[8].total / _vm.mittel[8].arr.length), (_vm.mittel[9].total / _vm.mittel[9].arr.length), (_vm.mittel[10].total / _vm.mittel[10].arr.length), (_vm.mittel[11].total / _vm.mittel[11].arr.length), (_vm.mittel[12].total / _vm.mittel[12].arr.length)]
        }
      ]
    },"options":{responsive: true, maintainAspectRatio: false, legend: { display: false, position: 'right'}, plugins: { datalabels: { color: '#000', formatter: function(value, context) {
    return value.toFixed(2) + ' ' + context.chart.data.datasets[context.datasetIndex].labels}, font: { weight: 'bold' }}}, title: { display: true, text: 'Mittlere Strukturen'
        }}}}):_vm._e(),_vm._v(" "),(_vm.benchlang === 'de')?_c('pie',{attrs:{"chart-data":{
      labels: ['bis 30 Jahre alt', '31-40 Jahre alt', '41-50 Jahre alt', '51-60 Jahre alt', 'über 61 Jahre alt'],
      datasets: [
        {
          backgroundColor: [
            '#FFC002',
            '#FF9901',
            '#9BBB59',
            '#77933C',
            '#376092'
          ],
          labels: '',
          data: [(_vm.gross[8].total / _vm.gross[8].arr.length), (_vm.gross[9].total / _vm.gross[9].arr.length), (_vm.gross[10].total / _vm.gross[10].arr.length), (_vm.gross[11].total / _vm.gross[11].arr.length), (_vm.gross[12].total / _vm.gross[12].arr.length)]
        }
      ]
    },"options":{responsive: true, maintainAspectRatio: false, legend: { display: false, position: 'bottom', fullWidth: true}, plugins: { datalabels: { color: '#000', formatter: function(value, context) {
    return value.toFixed(2) + ' ' + context.chart.data.datasets[context.datasetIndex].labels}, font: { weight: 'bold' }}}, title: { display: true, text: 'Grosse Strukturen'
        }}}}):_vm._e(),_vm._v(" "),(_vm.benchlang === 'de')?_c('div',{staticClass:"grid",staticStyle:{"align-content":"center","justify-content":"center"}},[_c('span',{staticClass:"legend yellow"},[_vm._v("bis 30 Jahre alt")]),_vm._v(" "),_c('span',{staticClass:"legend orange"},[_vm._v("31 - 40 Jahre alt")]),_vm._v(" "),_c('span',{staticClass:"legend green"},[_vm._v("41 - 50 Jahre alt")]),_vm._v(" "),_c('span',{staticClass:"legend greendark"},[_vm._v("51 - 60 Jahre alt")]),_vm._v(" "),_c('span',{staticClass:"legend blue"},[_vm._v("über 61 Jahre alt")])]):_vm._e(),_vm._v(" "),(_vm.benchlang === 'it')?_c('pie',{attrs:{"chart-data":{
      labels: ['fino 30 anni', '31-40 anni', '41-50 anni', '51-60 anni', 'oltre 61 anni'],
      datasets: [
        {
          backgroundColor: [
            '#FFC002',
            '#FF9901',
            '#9BBB59',
            '#77933C',
            '#376092'
          ],
          labels: '',
          data: [(_vm.klein[8].total / _vm.klein[8].arr.length), (_vm.klein[9].total / _vm.klein[9].arr.length), (_vm.klein[10].total / _vm.klein[10].arr.length), (_vm.klein[11].total / _vm.klein[11].arr.length), (_vm.klein[12].total / _vm.klein[12].arr.length)]
        }
      ]
    },"options":{responsive: true, maintainAspectRatio: false, legend: { display: false, position: 'right'}, plugins: { datalabels: { color: '#000', formatter: function(value, context) {
    return value.toFixed(2) + ' ' + context.chart.data.datasets[context.datasetIndex].labels}, font: { weight: 'bold' }}}, title: { display: true, text: 'Strutture piccole'
        }}}}):_vm._e(),_vm._v(" "),(_vm.benchlang === 'it')?_c('pie',{attrs:{"chart-data":{
      labels: ['fino 30 anni', '31-40 anni', '41-50 anni', '51-60 anni', 'oltre 61 anni'],
      datasets: [
        {
          backgroundColor: [
            '#FFC002',
            '#FF9901',
            '#9BBB59',
            '#77933C',
            '#376092'
          ],
          labels: '',
          data: [(_vm.mittel[8].total / _vm.mittel[8].arr.length), (_vm.mittel[9].total / _vm.mittel[9].arr.length), (_vm.mittel[10].total / _vm.mittel[10].arr.length), (_vm.mittel[11].total / _vm.mittel[11].arr.length), (_vm.mittel[12].total / _vm.mittel[12].arr.length)]
        }
      ]
    },"options":{responsive: true, maintainAspectRatio: false, legend: { display: false, position: 'right'}, plugins: { datalabels: { color: '#000', formatter: function(value, context) {
    return value.toFixed(2) + ' ' + context.chart.data.datasets[context.datasetIndex].labels}, font: { weight: 'bold' }}}, title: { display: true, text: 'Strutture medie'
        }}}}):_vm._e(),_vm._v(" "),(_vm.benchlang === 'it')?_c('pie',{attrs:{"chart-data":{
      labels: ['fino 30 anni', '31-40 anni', '41-50 anni', '51-60 anni', 'oltre 61 anni'],
      datasets: [
        {
          backgroundColor: [
            '#FFC002',
            '#FF9901',
            '#9BBB59',
            '#77933C',
            '#376092'
          ],
          labels: '',
          data: [(_vm.gross[8].total / _vm.gross[8].arr.length), (_vm.gross[9].total / _vm.gross[9].arr.length), (_vm.gross[10].total / _vm.gross[10].arr.length), (_vm.gross[11].total / _vm.gross[11].arr.length), (_vm.gross[12].total / _vm.gross[12].arr.length)]
        }
      ]
    },"options":{responsive: true, maintainAspectRatio: false, legend: { display: false, position: 'bottom', fullWidth: true}, plugins: { datalabels: { color: '#000', formatter: function(value, context) {
    return value.toFixed(2) + ' ' + context.chart.data.datasets[context.datasetIndex].labels}, font: { weight: 'bold' }}}, title: { display: true, text: 'Strutture grandi'
        }}}}):_vm._e(),_vm._v(" "),(_vm.benchlang === 'it')?_c('div',{staticClass:"grid",staticStyle:{"align-content":"center","justify-content":"center"}},[_c('span',{staticClass:"legend yellow"},[_vm._v("fino 30 anni")]),_vm._v(" "),_c('span',{staticClass:"legend orange"},[_vm._v("31 - 40 anni")]),_vm._v(" "),_c('span',{staticClass:"legend green"},[_vm._v("41 - 50 anni")]),_vm._v(" "),_c('span',{staticClass:"legend greendark"},[_vm._v("51 - 60 anni")]),_vm._v(" "),_c('span',{staticClass:"legend blue"},[_vm._v("oltre 61 anni")])]):_vm._e()],1),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.content[5])}}),_vm._v(" "),(_vm.benchlang === 'de')?_c('h5',[_vm._v("Nicht-Betreuungsbereich: Mitarbeiter Altersstufen (Mittelwerte in Prozent)")]):_vm._e(),_vm._v(" "),(_vm.benchlang === 'it')?_c('h5',[_vm._v("Settore non-assistenziale: fasce d´etá dei collaboratori (media in %)")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"grid",staticStyle:{"grid-template-columns":"1fr 1fr"}},[(_vm.benchlang === 'de')?_c('pie',{attrs:{"chart-data":{
      labels: ['bis 30 Jahre alt', '31-40 Jahre alt', '41-50 Jahre alt', '51-60 Jahre alt', 'über 61 Jahre alt'],
      datasets: [
        {
          backgroundColor: [
            '#FFC002',
            '#FF9901',
            '#9BBB59',
            '#77933C',
            '#376092'
          ],
          labels: '',
          data: [(_vm.klein[13].total / _vm.klein[13].arr.length), (_vm.klein[14].total / _vm.klein[14].arr.length), (_vm.klein[15].total / _vm.klein[15].arr.length), (_vm.klein[16].total / _vm.klein[16].arr.length), (_vm.klein[17].total / _vm.klein[17].arr.length)]
        }
      ]
    },"options":{responsive: true, maintainAspectRatio: false, legend: { display: false, position: 'right'}, plugins: { datalabels: { color: '#000', align: 'center', formatter: function(value, context) {
    return value.toFixed(2) + ' ' + context.chart.data.datasets[context.datasetIndex].labels}, font: { weight: 'bold' }}}, title: { display: true, text: 'Kleine Strukturen'
        }}}}):_vm._e(),_vm._v(" "),(_vm.benchlang === 'de')?_c('pie',{attrs:{"chart-data":{
      labels: ['bis 30 Jahre alt', '31-40 Jahre alt', '41-50 Jahre alt', '51-60 Jahre alt', 'über 61 Jahre alt'],
      datasets: [
        {
          backgroundColor: [
            '#FFC002',
            '#FF9901',
            '#9BBB59',
            '#77933C',
            '#376092'
          ],
          labels: '',
          data: [(_vm.mittel[13].total / _vm.mittel[13].arr.length), (_vm.mittel[14].total / _vm.mittel[14].arr.length), (_vm.mittel[15].total / _vm.mittel[15].arr.length), (_vm.mittel[16].total / _vm.mittel[16].arr.length), (_vm.mittel[17].total / _vm.mittel[17].arr.length)]
        }
      ]
    },"options":{responsive: true, maintainAspectRatio: false, legend: { display: false, position: 'right'}, plugins: { datalabels: { color: '#000', formatter: function(value, context) {
    return value.toFixed(2) + ' ' + context.chart.data.datasets[context.datasetIndex].labels}, font: { weight: 'bold' }}}, title: { display: true, text: 'Mittlere Strukturen'
        }}}}):_vm._e(),_vm._v(" "),(_vm.benchlang === 'de')?_c('pie',{attrs:{"chart-data":{
      labels: ['bis 30 Jahre alt', '31-40 Jahre alt', '41-50 Jahre alt', '51-60 Jahre alt', 'über 61 Jahre alt'],
      datasets: [
        {
          backgroundColor: [
            '#FFC002',
            '#FF9901',
            '#9BBB59',
            '#77933C',
            '#376092'
          ],
          labels: '',
          data: [(_vm.gross[13].total / _vm.gross[13].arr.length), (_vm.gross[14].total / _vm.gross[14].arr.length), (_vm.gross[15].total / _vm.gross[15].arr.length), (_vm.gross[16].total / _vm.gross[16].arr.length), (_vm.gross[17].total / _vm.gross[17].arr.length)]
        }
      ]
    },"options":{responsive: true, maintainAspectRatio: false, legend: { display: false, position: 'bottom', fullWidth: true}, plugins: { datalabels: { color: '#000', formatter: function(value, context) {
    return value.toFixed(2) + ' ' + context.chart.data.datasets[context.datasetIndex].labels}, font: { weight: 'bold' }}}, title: { display: true, text: 'Grosse Strukturen'
        }}}}):_vm._e(),_vm._v(" "),(_vm.benchlang === 'de')?_c('div',{staticClass:"grid",staticStyle:{"align-content":"center","justify-content":"center"}},[_c('span',{staticClass:"legend yellow"},[_vm._v("bis 30 Jahre alt")]),_vm._v(" "),_c('span',{staticClass:"legend orange"},[_vm._v("31 - 40 Jahre alt")]),_vm._v(" "),_c('span',{staticClass:"legend green"},[_vm._v("41 - 50 Jahre alt")]),_vm._v(" "),_c('span',{staticClass:"legend greendark"},[_vm._v("51 - 60 Jahre alt")]),_vm._v(" "),_c('span',{staticClass:"legend blue"},[_vm._v("über 61 Jahre alt")])]):_vm._e(),_vm._v(" "),(_vm.benchlang === 'it')?_c('pie',{attrs:{"chart-data":{
      labels: ['fino 30 anni', '31-40 anni', '41-50 anni', '51-60 anni', 'oltre 61 anni'],
      datasets: [
        {
          backgroundColor: [
            '#FFC002',
            '#FF9901',
            '#9BBB59',
            '#77933C',
            '#376092'
          ],
          labels: '',
          data: [(_vm.klein[13].total / _vm.klein[13].arr.length), (_vm.klein[14].total / _vm.klein[14].arr.length), (_vm.klein[15].total / _vm.klein[15].arr.length), (_vm.klein[16].total / _vm.klein[16].arr.length), (_vm.klein[17].total / _vm.klein[17].arr.length)]
        }
      ]
    },"options":{responsive: true, maintainAspectRatio: false, legend: { display: false, position: 'right'}, plugins: { datalabels: { color: '#000', align: 'center', formatter: function(value, context) {
    return value.toFixed(2) + ' ' + context.chart.data.datasets[context.datasetIndex].labels}, font: { weight: 'bold' }}}, title: { display: true, text: 'Strutture piccole'
        }}}}):_vm._e(),_vm._v(" "),(_vm.benchlang === 'it')?_c('pie',{attrs:{"chart-data":{
      labels: ['fino 30 anni', '31-40 anni', '41-50 anni', '51-60 anni', 'oltre 61 anni'],
      datasets: [
        {
          backgroundColor: [
            '#FFC002',
            '#FF9901',
            '#9BBB59',
            '#77933C',
            '#376092'
          ],
          labels: '',
          data: [(_vm.mittel[13].total / _vm.mittel[13].arr.length), (_vm.mittel[14].total / _vm.mittel[14].arr.length), (_vm.mittel[15].total / _vm.mittel[15].arr.length), (_vm.mittel[16].total / _vm.mittel[16].arr.length), (_vm.mittel[17].total / _vm.mittel[17].arr.length)]
        }
      ]
    },"options":{responsive: true, maintainAspectRatio: false, legend: { display: false, position: 'right'}, plugins: { datalabels: { color: '#000', formatter: function(value, context) {
    return value.toFixed(2) + ' ' + context.chart.data.datasets[context.datasetIndex].labels}, font: { weight: 'bold' }}}, title: { display: true, text: 'Strutture medie'
        }}}}):_vm._e(),_vm._v(" "),(_vm.benchlang === 'it')?_c('pie',{attrs:{"chart-data":{
      labels: ['fino 30 anni', '31-40 anni', '41-50 anni', '51-60 anni', 'oltre 61 anni'],
      datasets: [
        {
          backgroundColor: [
            '#FFC002',
            '#FF9901',
            '#9BBB59',
            '#77933C',
            '#376092'
          ],
          labels: '',
          data: [(_vm.gross[13].total / _vm.gross[13].arr.length), (_vm.gross[14].total / _vm.gross[14].arr.length), (_vm.gross[15].total / _vm.gross[15].arr.length), (_vm.gross[16].total / _vm.gross[16].arr.length), (_vm.gross[17].total / _vm.gross[17].arr.length)]
        }
      ]
    },"options":{responsive: true, maintainAspectRatio: false, legend: { display: false, position: 'bottom', fullWidth: true}, plugins: { datalabels: { color: '#000', formatter: function(value, context) {
    return value.toFixed(2) + ' ' + context.chart.data.datasets[context.datasetIndex].labels}, font: { weight: 'bold' }}}, title: { display: true, text: 'Strutture grandi'
        }}}}):_vm._e(),_vm._v(" "),(_vm.benchlang === 'it')?_c('div',{staticClass:"grid",staticStyle:{"align-content":"center","justify-content":"center"}},[_c('span',{staticClass:"legend yellow"},[_vm._v("fino 30 anni")]),_vm._v(" "),_c('span',{staticClass:"legend orange"},[_vm._v("31 - 40 anni")]),_vm._v(" "),_c('span',{staticClass:"legend green"},[_vm._v("41 - 50 anni")]),_vm._v(" "),_c('span',{staticClass:"legend greendark"},[_vm._v("51 - 60 anni")]),_vm._v(" "),_c('span',{staticClass:"legend blue"},[_vm._v("oltre 61 anni")])]):_vm._e()],1),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.content[6])}}),_vm._v(" "),(_vm.benchlang === 'de')?_c('h2',[_vm._v("5. PROZESSE")]):_vm._e(),_vm._v(" "),(_vm.benchlang === 'it')?_c('h2',[_vm._v("5. PROCESSI")]):_vm._e(),_vm._v(" "),(_vm.benchlang === 'de')?_c('h5',[_vm._v("Anzahl dokumentierte Schmerzeinschätzung (Mittelwerte)")]):_vm._e(),_vm._v(" "),(_vm.benchlang === 'it')?_c('h5',[_vm._v("Numero delle valutazioni del dolore documentate (media)")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"spacer sm"}),_vm._v(" "),(_vm.benchlang === 'de')?_c('stats',{attrs:{"chart-data":{
                    labels: [],
                    datasets: [
                      {
                        label: 'Durchschnitt',
                        backgroundColor: '#376092',
                        data: [((_vm.klein[18].totval / _vm.klein[18].val.length)+(_vm.mittel[18].totval / _vm.mittel[18].val.length)+(_vm.gross[18].totval / _vm.gross[18].val.length))/3]
                      }
                    ]
                  },"options":{responsive: false, maintainAspectRatio: true, legend: {display: true, position: 'right'}, plugins: { datalabels: { color: '#000', font: { weight: 'bold' }, anchor: 'end', align: 'end' }}, scales: { yAxes: [{ ticks: { beginAtZero:true }}] }, title: { display: false, text: 'Anzahl dokumentierte Schmerzeinschätzung (Mittelwerte)', padding: 40 }}}}):_vm._e(),_vm._v(" "),(_vm.benchlang === 'it')?_c('stats',{attrs:{"chart-data":{
                    labels: [''],
                    datasets: [
                      {
                        label: 'Media',
                        backgroundColor: '#376092',
                        data: [((_vm.klein[18].totval / _vm.klein[18].val.length)+(_vm.mittel[18].totval / _vm.mittel[18].val.length)+(_vm.gross[18].totval / _vm.gross[18].val.length))/3]
                      }
                    ]
                  },"options":{responsive: false, maintainAspectRatio: true, legend: {display: true, position: 'right'}, plugins: { datalabels: { color: '#000', font: { weight: 'bold' }, anchor: 'end', align: 'end' }}, scales: { yAxes: [{ ticks: { beginAtZero:true }}] }, title: { display: false, text: 'Numero delle valutazioni del dolore documentate (media)', padding: 40 }}}}):_vm._e(),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.content[7])}}),_vm._v(" "),(_vm.benchlang === 'de')?_c('h5',[_vm._v("Anteil Bewohner mit Dekubiti (Mittelwerte in Prozent)")]):_vm._e(),_vm._v(" "),(_vm.benchlang === 'it')?_c('h5',[_vm._v("Residenti con decubiti (media)")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"spacer sm"}),_vm._v(" "),(_vm.benchlang === 'de')?_c('stats',{attrs:{"chart-data":{
                    labels: [['Anteil Bewohner mit Dekubiti','(Stichtag: 31.12.17)'],['Anteil Entstehungsort im Heim','(Stichtag 31.12.17)'],['Anteil Entstehungsort außerhalb des Heimes','(Stichtag 31.12.17)']],
                    datasets: [
                      {
                        label: 'Kleine Strukturen',
                        backgroundColor: '#FFC002',
                        data: [_vm.klein[19].total / _vm.klein[19].arr.length, _vm.klein[20].total / _vm.klein[20].arr.length, _vm.klein[21].total / _vm.klein[21].arr.length]
                      },
                      {
                        label: 'Mittlere Strukturen',
                        backgroundColor: '#9BBB59',
                        data: [_vm.mittel[19].total / _vm.mittel[19].arr.length, _vm.mittel[20].total / _vm.mittel[20].arr.length, _vm.mittel[21].total / _vm.mittel[21].arr.length]
                      },
                      {
                        label: 'Grosse Strukturen',
                        backgroundColor: '#77933C',
                        data: [_vm.gross[19].total / _vm.gross[19].arr.length, _vm.gross[20].total / _vm.gross[20].arr.length, _vm.gross[21].total / _vm.gross[21].arr.length]
                      },
                      {
                        label: 'Durchschnitt',
                        backgroundColor: '#376092',
                        data: [((_vm.klein[19].total / _vm.klein[19].arr.length)+(_vm.mittel[19].total / _vm.mittel[19].arr.length)+(_vm.gross[19].total / _vm.gross[19].arr.length))/3, ((_vm.klein[20].total / _vm.klein[20].arr.length)+(_vm.mittel[20].total / _vm.mittel[20].arr.length)+(_vm.gross[20].total / _vm.gross[20].arr.length))/3, ((_vm.klein[21].total / _vm.klein[21].arr.length)+(_vm.mittel[21].total / _vm.mittel[21].arr.length)+(_vm.gross[21].total / _vm.gross[21].arr.length))/3]
                      }
                    ]
                  },"options":{responsive: true, maintainAspectRatio: false, legend: { display: true, position: 'right'}, plugins: { datalabels: { color: '#000', font: { weight: 'bold' }, anchor: 'end', align: 'end' } }, scales: { yAxes: [{ ticks: { beginAtZero:true } }] }, title: { display: false, text: 'Bewohner mit Dekubiti (Mittelwerte)', padding: 40
        }}}}):_vm._e(),_vm._v(" "),(_vm.benchlang === 'it')?_c('stats',{attrs:{"chart-data":{
                    labels: [['Quota percentuale e numero', 'dei residenti con decubiti (Senso 6)', 'Giorno di riferimento: 31.12.'], ['Quota percentuale e numero', 'dei residenti con decubiti con luogo', 'd’origine nella residenza', 'Giorno di riferimento: 31.12.'], ['Quota percentuale e numero', 'dei residenti con decubiti', 'con luogo d’origine al di fuori della residenza', 'Giorno di riferimento: 31.12.']],
                    datasets: [
                      {
                        label: 'Strutture piccole',
                        backgroundColor: '#FFC002',
                        data: [_vm.klein[19].total / _vm.klein[19].arr.length, _vm.klein[20].total / _vm.klein[20].arr.length, _vm.klein[21].total / _vm.klein[21].arr.length]
                      },
                      {
                        label: 'Strutture medie',
                        backgroundColor: '#9BBB59',
                        data: [_vm.mittel[19].total / _vm.mittel[19].arr.length, _vm.mittel[20].total / _vm.mittel[20].arr.length, _vm.mittel[21].total / _vm.mittel[21].arr.length]
                      },
                      {
                        label: 'Strutture grandi',
                        backgroundColor: '#77933C',
                        data: [_vm.gross[19].total / _vm.gross[19].arr.length, _vm.gross[20].total / _vm.gross[20].arr.length, _vm.gross[21].total / _vm.gross[21].arr.length]
                      },
                      {
                        label: 'Media',
                        backgroundColor: '#376092',
                        data: [((_vm.klein[19].total / _vm.klein[19].arr.length)+(_vm.mittel[19].total / _vm.mittel[19].arr.length)+(_vm.gross[19].total / _vm.gross[19].arr.length))/3, ((_vm.klein[20].total / _vm.klein[20].arr.length)+(_vm.mittel[20].total / _vm.mittel[20].arr.length)+(_vm.gross[20].total / _vm.gross[20].arr.length))/3, ((_vm.klein[21].total / _vm.klein[21].arr.length)+(_vm.mittel[21].total / _vm.mittel[21].arr.length)+(_vm.gross[21].total / _vm.gross[21].arr.length))/3]
                      }
                    ]
                  },"options":{responsive: true, maintainAspectRatio: false, legend: { display: true, position: 'right'}, plugins: { datalabels: { color: '#000', font: { weight: 'bold' }, anchor: 'end', align: 'end' } }, scales: { yAxes: [{ ticks: { beginAtZero:true } }] }, title: { display: false, text: 'Residenti con decubiti (media)', padding: 40
        }}}}):_vm._e(),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.content[8])}}),_vm._v(" "),(_vm.benchlang === 'de')?_c('h5',[_vm._v("Anzahl Stürze mit Folge (Mittelwerte)")]):_vm._e(),_vm._v(" "),(_vm.benchlang === 'it')?_c('h5',[_vm._v("Numero delle cadute con conseguenze (media)")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"spacer sm"}),_vm._v(" "),(_vm.benchlang === 'de')?_c('stats',{attrs:{"chart-data":{
                    labels: [''],
                    datasets: [
                      {
                        label: 'Kleine Strukturen',
                        backgroundColor: '#FFC002',
                        data: [_vm.klein[22].totval / _vm.klein[22].val.length]
                      },
                      {
                        label: 'Mittlere Strukturen',
                        backgroundColor: '#9BBB59',
                        data: [_vm.mittel[22].totval / _vm.mittel[22].val.length]
                      },
                      {
                        label: 'Grosse Strukturen',
                        backgroundColor: '#77933C',
                        data: [_vm.gross[22].totval / _vm.gross[22].val.length]
                      },
                      {
                        label: 'Durchschnitt',
                        backgroundColor: '#376092',
                        data: [((_vm.klein[22].totval / _vm.klein[22].val.length)+(_vm.mittel[22].totval / _vm.mittel[22].val.length)+(_vm.gross[22].totval / _vm.gross[22].val.length))/3]
                      }
                    ]
                  },"options":{responsive: true, maintainAspectRatio: false, legend: {display: true, position: 'right'}, plugins: { datalabels: { color: '#000', font: { weight: 'bold' }, anchor: 'end', align: 'end' }}, scales: { yAxes: [{ ticks: { beginAtZero:true }}] }, title: { display: false, text: 'Anzahl Stürze mit Folge (Mittelwerte)', padding: 40 }}}}):_vm._e(),_vm._v(" "),(_vm.benchlang === 'it')?_c('stats',{attrs:{"chart-data":{
                    labels: [''],
                    datasets: [
                      {
                        label: 'Strutture piccole',
                        backgroundColor: '#FFC002',
                        data: [_vm.klein[22].totval / _vm.klein[22].val.length]
                      },
                      {
                        label: 'Strutture medie',
                        backgroundColor: '#9BBB59',
                        data: [_vm.mittel[22].totval / _vm.mittel[22].val.length]
                      },
                      {
                        label: 'Strutture grandi',
                        backgroundColor: '#77933C',
                        data: [_vm.gross[22].totval / _vm.gross[22].val.length]
                      },
                      {
                        label: 'Media',
                        backgroundColor: '#376092',
                        data: [((_vm.klein[22].totval / _vm.klein[22].val.length)+(_vm.mittel[22].totval / _vm.mittel[22].val.length)+(_vm.gross[22].totval / _vm.gross[22].val.length))/3]
                      }
                    ]
                  },"options":{responsive: true, maintainAspectRatio: false, legend: {display: true, position: 'right'}, plugins: { datalabels: { color: '#000', font: { weight: 'bold' }, anchor: 'end', align: 'end' }}, scales: { yAxes: [{ ticks: { beginAtZero:true }}] }, title: { display: false, text: 'Numero delle cadute con conseguenze (media)', padding: 40 }}}}):_vm._e(),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.content[9])}}),_vm._v(" "),(_vm.benchlang === 'de')?_c('h5',[_vm._v("Anzahl Stürze ohne Folge (Mittelwerte)")]):_vm._e(),_vm._v(" "),(_vm.benchlang === 'it')?_c('h5',[_vm._v("Numero delle cadute senza conseguenze (media)")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"spacer sm"}),_vm._v(" "),(_vm.benchlang === 'de')?_c('stats',{attrs:{"chart-data":{
                    labels: [''],
                    datasets: [
                      {
                        label: 'Kleine Strukturen',
                        backgroundColor: '#FFC002',
                        data: [_vm.klein[23].totval / _vm.klein[23].val.length]
                      },
                      {
                        label: 'Mittlere Strukturen',
                        backgroundColor: '#9BBB59',
                        data: [_vm.mittel[23].totval / _vm.mittel[23].val.length]
                      },
                      {
                        label: 'Grosse Strukturen',
                        backgroundColor: '#77933C',
                        data: [_vm.gross[23].totval / _vm.gross[23].val.length]
                      },
                      {
                        label: 'Durchschnitt',
                        backgroundColor: '#376092',
                        data: [((_vm.klein[23].totval / _vm.klein[23].val.length)+(_vm.mittel[23].totval / _vm.mittel[23].val.length)+(_vm.gross[23].totval / _vm.gross[23].val.length))/3]
                      }
                    ]
                  },"options":{responsive: true, maintainAspectRatio: false, legend: {display: true, position: 'right'}, plugins: { datalabels: { color: '#000', font: { weight: 'bold' }, anchor: 'end', align: 'end' }}, scales: { yAxes: [{ ticks: { beginAtZero:true }}] }, title: { display: false, text: 'Anzahl Stürze ohne Folge (Mittelwerte)', padding: 40 }}}}):_vm._e(),_vm._v(" "),(_vm.benchlang === 'it')?_c('stats',{attrs:{"chart-data":{
                    labels: [''],
                    datasets: [
                      {
                        label: 'Strutture piccole',
                        backgroundColor: '#FFC002',
                        data: [_vm.klein[23].totval / _vm.klein[23].val.length]
                      },
                      {
                        label: 'Strutture medie',
                        backgroundColor: '#9BBB59',
                        data: [_vm.mittel[23].totval / _vm.mittel[23].val.length]
                      },
                      {
                        label: 'Strutture grandi',
                        backgroundColor: '#77933C',
                        data: [_vm.gross[23].totval / _vm.gross[23].val.length]
                      },
                      {
                        label: 'Media',
                        backgroundColor: '#376092',
                        data: [((_vm.klein[23].totval / _vm.klein[23].val.length)+(_vm.mittel[23].totval / _vm.mittel[23].val.length)+(_vm.gross[23].totval / _vm.gross[23].val.length))/3]
                      }
                    ]
                  },"options":{responsive: true, maintainAspectRatio: false, legend: {display: true, position: 'right'}, plugins: { datalabels: { color: '#000', font: { weight: 'bold' }, anchor: 'end', align: 'end' }}, scales: { yAxes: [{ ticks: { beginAtZero:true }}] }, title: { display: false, text: 'Numero delle cadute senza conseguenze (media)', padding: 40 }}}}):_vm._e(),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.content[10])}}),_vm._v(" "),(_vm.benchlang === 'de')?_c('h5',[_vm._v("Anteil Bewohner mit Einsatz freiheitseinschränkender Maßnahmen (Mittelwerte in Prozent zum Stichtag 31.12."+_vm._s(_vm.value)+")")]):_vm._e(),_vm._v(" "),(_vm.benchlang === 'it')?_c('h5',[_vm._v("Residenti con degli interventi di contenzione fisica (media)")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"spacer sm"}),_vm._v(" "),(_vm.benchlang === 'de')?_c('stats',{attrs:{"chart-data":{
                    labels: [''],
                    datasets: [
                      {
                        label: 'Kleine Strukturen',
                        backgroundColor: '#FFC002',
                        data: [_vm.klein[24].total / _vm.klein[24].arr.length]
                      },
                      {
                        label: 'Mittlere Strukturen',
                        backgroundColor: '#9BBB59',
                        data: [_vm.mittel[24].total / _vm.mittel[24].arr.length]
                      },
                      {
                        label: 'Grosse Strukturen',
                        backgroundColor: '#77933C',
                        data: [_vm.gross[24].total / _vm.gross[24].arr.length]
                      },
                      {
                        label: 'Durchschnitt',
                        backgroundColor: '#376092',
                        data: [((_vm.klein[24].total / _vm.klein[24].arr.length)+(_vm.mittel[24].total / _vm.mittel[24].arr.length)+(_vm.gross[24].total / _vm.gross[24].arr.length))/3]
                      }
                    ]
                  },"options":{responsive: true, maintainAspectRatio: false, legend: {display: true, position: 'right'}, plugins: { datalabels: { color: '#000', font: { weight: 'bold' }, anchor: 'end', align: 'end' }}, scales: { yAxes: [{ ticks: { beginAtZero:true }}] }, title: { display: false, text: 'Bewohner mit Einsatz freiheitseinschränkender Maßnahmen (Mittelwerte)', padding: 40 }}}}):_vm._e(),_vm._v(" "),(_vm.benchlang === 'it')?_c('stats',{attrs:{"chart-data":{
                    labels: [''],
                    datasets: [
                      {
                        label: 'Strutture piccole',
                        backgroundColor: '#FFC002',
                        data: [_vm.klein[24].total / _vm.klein[24].arr.length]
                      },
                      {
                        label: 'Strutture medie',
                        backgroundColor: '#9BBB59',
                        data: [_vm.mittel[24].total / _vm.mittel[24].arr.length]
                      },
                      {
                        label: 'Strutture grandi',
                        backgroundColor: '#77933C',
                        data: [_vm.gross[24].total / _vm.gross[24].arr.length]
                      },
                      {
                        label: 'Media',
                        backgroundColor: '#376092',
                        data: [((_vm.klein[24].total / _vm.klein[24].arr.length)+(_vm.mittel[24].total / _vm.mittel[24].arr.length)+(_vm.gross[24].total / _vm.gross[24].arr.length))/3]
                      }
                    ]
                  },"options":{responsive: true, maintainAspectRatio: false, legend: {display: true, position: 'right'}, plugins: { datalabels: { color: '#000', font: { weight: 'bold' }, anchor: 'end', align: 'end' }}, scales: { yAxes: [{ ticks: { beginAtZero:true }}] }, title: { display: false, text: 'Residenti con degli interventi di contenzione fisica (media)', padding: 40 }}}}):_vm._e(),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.content[11])}}),_vm._v(" "),(_vm.benchlang === 'de')?_c('h5',[_vm._v("Anzahl quittierter REHA-Leistungen (Mittelwerte)")]):_vm._e(),_vm._v(" "),(_vm.benchlang === 'it')?_c('h5',[_vm._v("Numero delle prestazioni di riabilitazione validate/firmate (media)")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"spacer sm"}),_vm._v(" "),(_vm.benchlang === 'de')?_c('stats',{attrs:{"chart-data":{
                    labels: [''],
                    datasets: [
                      {
                        label: 'Kleine Strukturen',
                        backgroundColor: '#FFC002',
                        data: [_vm.klein[25].totval / _vm.klein[25].val.length]
                      },
                      {
                        label: 'Mittlere Strukturen',
                        backgroundColor: '#9BBB59',
                        data: [_vm.mittel[25].totval / _vm.mittel[25].val.length]
                      },
                      {
                        label: 'Grosse Strukturen',
                        backgroundColor: '#77933C',
                        data: [_vm.gross[25].totval / _vm.gross[25].val.length]
                      },
                      {
                        label: 'Durchschnitt',
                        backgroundColor: '#376092',
                        data: [((_vm.klein[25].totval / _vm.klein[25].val.length)+(_vm.mittel[25].totval / _vm.mittel[25].val.length)+(_vm.gross[25].totval / _vm.gross[25].val.length))/3]
                      }
                    ]
                  },"options":{responsive: true, maintainAspectRatio: false, legend: {display: true, position: 'right'}, plugins: { datalabels: { color: '#000', font: { weight: 'bold' }, anchor: 'end', align: 'end' }}, scales: { yAxes: [{ ticks: { beginAtZero:true }}] }, title: { display: false, text: 'Anzahl quittierter REHA-Leistungen (Mittelwerte)', padding: 40 }}}}):_vm._e(),_vm._v(" "),(_vm.benchlang === 'it')?_c('stats',{attrs:{"chart-data":{
                    labels: [''],
                    datasets: [
                      {
                        label: 'Strutture piccole',
                        backgroundColor: '#FFC002',
                        data: [_vm.klein[25].totval / _vm.klein[25].val.length]
                      },
                      {
                        label: 'Strutture medie',
                        backgroundColor: '#9BBB59',
                        data: [_vm.mittel[25].totval / _vm.mittel[25].val.length]
                      },
                      {
                        label: 'Strutture grandi',
                        backgroundColor: '#77933C',
                        data: [_vm.gross[25].totval / _vm.gross[25].val.length]
                      },
                      {
                        label: 'Media',
                        backgroundColor: '#376092',
                        data: [((_vm.klein[25].totval / _vm.klein[25].val.length)+(_vm.mittel[25].totval / _vm.mittel[25].val.length)+(_vm.gross[25].totval / _vm.gross[25].val.length))/3]
                      }
                    ]
                  },"options":{responsive: true, maintainAspectRatio: false, legend: {display: true, position: 'right'}, plugins: { datalabels: { color: '#000', font: { weight: 'bold' }, anchor: 'end', align: 'end' }}, scales: { yAxes: [{ ticks: { beginAtZero:true }}] }, title: { display: false, text: 'Numero delle prestazioni di riabilitazione validate/firmate (media)', padding: 40 }}}}):_vm._e(),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.content[12])}}),_vm._v(" "),(_vm.benchlang === 'de')?_c('h5',[_vm._v("Anzahl quittierter Leistungen der Tagesbetreuung (Mittelwerte)")]):_vm._e(),_vm._v(" "),(_vm.benchlang === 'it')?_c('h5',[_vm._v("Numero delle prestazioni di assistenza giornaliera/animazione validate/firmate (media)")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"spacer sm"}),_vm._v(" "),(_vm.benchlang === 'de')?_c('stats',{attrs:{"chart-data":{
                    labels: [''],
                    datasets: [
                      {
                        label: 'Kleine Strukturen',
                        backgroundColor: '#FFC002',
                        data: [_vm.klein[26].totval / _vm.klein[26].val.length]
                      },
                      {
                        label: 'Mittlere Strukturen',
                        backgroundColor: '#9BBB59',
                        data: [_vm.mittel[26].totval / _vm.mittel[26].val.length]
                      },
                      {
                        label: 'Grosse Strukturen',
                        backgroundColor: '#77933C',
                        data: [_vm.gross[26].totval / _vm.gross[26].val.length]
                      },
                      {
                        label: 'Durchschnitt',
                        backgroundColor: '#376092',
                        data: [((_vm.klein[26].totval / _vm.klein[26].val.length)+(_vm.mittel[26].totval / _vm.mittel[26].val.length)+(_vm.gross[26].totval / _vm.gross[26].val.length))/3]
                      }
                    ]
                  },"options":{responsive: true, maintainAspectRatio: false, legend: {display: true, position: 'right'}, plugins: { datalabels: { color: '#000', font: { weight: 'bold' }, anchor: 'end', align: 'end' }}, scales: { yAxes: [{ ticks: { beginAtZero:true }}] }, title: { display: false, text: 'Anzahl quittierter Leistungen der Tagesbetreuung (Mittelwerte)', padding: 40 }}}}):_vm._e(),_vm._v(" "),(_vm.benchlang === 'it')?_c('stats',{attrs:{"chart-data":{
                    labels: [''],
                    datasets: [
                      {
                        label: 'Strutture piccole',
                        backgroundColor: '#FFC002',
                        data: [_vm.klein[26].totval / _vm.klein[26].val.length]
                      },
                      {
                        label: 'Strutture medie',
                        backgroundColor: '#9BBB59',
                        data: [_vm.mittel[26].totval / _vm.mittel[26].val.length]
                      },
                      {
                        label: 'Strutture grandi',
                        backgroundColor: '#77933C',
                        data: [_vm.gross[26].totval / _vm.gross[26].val.length]
                      },
                      {
                        label: 'Media',
                        backgroundColor: '#376092',
                        data: [((_vm.klein[26].totval / _vm.klein[26].val.length)+(_vm.mittel[26].totval / _vm.mittel[26].val.length)+(_vm.gross[26].totval / _vm.gross[26].val.length))/3]
                      }
                    ]
                  },"options":{responsive: true, maintainAspectRatio: false, legend: {display: true, position: 'right'}, plugins: { datalabels: { color: '#000', font: { weight: 'bold' }, anchor: 'end', align: 'end' }}, scales: { yAxes: [{ ticks: { beginAtZero:true }}] }, title: { display: false, text: 'Numero delle prestazioni di assistenza giornaliera/animazione validate/firmate (media)', padding: 40 }}}}):_vm._e(),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.content[13])}}),_vm._v(" "),(_vm.benchlang === 'de')?_c('h5',[_vm._v("Ausgaben für Lebensmittel und Getränke in Euro pro Heimbewohner pro Tag (Mittelwerte)")]):_vm._e(),_vm._v(" "),(_vm.benchlang === 'it')?_c('h5',[_vm._v("Spese per alimentari e bibite in euro per residente al giorno (media)")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"spacer sm"}),_vm._v(" "),(_vm.benchlang === 'de')?_c('stats',{attrs:{"chart-data":{
                    labels: [''],
                    datasets: [
                      {
                        label: 'Kleine Strukturen',
                        backgroundColor: '#FFC002',
                        data: [_vm.klein[27].toteur / _vm.klein[27].eur.length]
                      },
                      {
                        label: 'Mittlere Strukturen',
                        backgroundColor: '#9BBB59',
                        data: [_vm.mittel[27].toteur / _vm.mittel[27].eur.length]
                      },
                      {
                        label: 'Grosse Strukturen',
                        backgroundColor: '#77933C',
                        data: [_vm.gross[27].toteur / _vm.gross[27].eur.length]
                      },
                      {
                        label: 'Durchschnitt',
                        backgroundColor: '#376092',
                        data: [((_vm.klein[27].toteur / _vm.klein[27].eur.length)+(_vm.mittel[27].toteur / _vm.mittel[27].eur.length)+(_vm.gross[27].toteur / _vm.gross[27].eur.length))/3]
                      }
                    ]
                  },"options":{responsive: true, maintainAspectRatio: false, legend: {display: true, position: 'right'}, plugins: { datalabels: { color: '#000', font: { weight: 'bold' }, anchor: 'end', align: 'end' }}, scales: { yAxes: [{ ticks: { beginAtZero:true }}] }, title: { display: false, text: 'Ausgaben für Lebensmittel und Getränke in € pro Heimbewohner pro Tag (Mittelwerte)', padding: 40 }}}}):_vm._e(),_vm._v(" "),(_vm.benchlang === 'it')?_c('stats',{attrs:{"chart-data":{
                    labels: [''],
                    datasets: [
                      {
                        label: 'Strutture piccole',
                        backgroundColor: '#FFC002',
                        data: [_vm.klein[27].toteur / _vm.klein[27].eur.length]
                      },
                      {
                        label: 'Strutture medie',
                        backgroundColor: '#9BBB59',
                        data: [_vm.mittel[27].toteur / _vm.mittel[27].eur.length]
                      },
                      {
                        label: 'Strutture grandi',
                        backgroundColor: '#77933C',
                        data: [_vm.gross[27].toteur / _vm.gross[27].eur.length]
                      },
                      {
                        label: 'Media',
                        backgroundColor: '#376092',
                        data: [((_vm.klein[27].toteur / _vm.klein[27].eur.length)+(_vm.mittel[27].toteur / _vm.mittel[27].eur.length)+(_vm.gross[27].toteur / _vm.gross[27].eur.length))/3]
                      }
                    ]
                  },"options":{responsive: true, maintainAspectRatio: false, legend: {display: true, position: 'right'}, plugins: { datalabels: { color: '#000', font: { weight: 'bold' }, anchor: 'end', align: 'end' }}, scales: { yAxes: [{ ticks: { beginAtZero:true }}] }, title: { display: false, text: 'Spese per alimentari e bibite in euro per residente al giorno (media)', padding: 40 }}}}):_vm._e(),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.content[14])}}),_vm._v(" "),(_vm.benchlang === 'de')?_c('h5',[_vm._v("Personalkosten Küche für die Zubereitung von Lebensmitteln und den Abwasch in Euro pro Heimbewohner pro Tag (Mittelwerte)")]):_vm._e(),_vm._v(" "),(_vm.benchlang === 'it')?_c('h5',[_vm._v("Costi per il personale di cucina per la preparazione degli alimenti e per la rigovernatura per residente in euro, al giorno (media)")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"spacer sm"}),_vm._v(" "),(_vm.benchlang === 'de')?_c('stats',{attrs:{"chart-data":{
                    labels: [''],
                    datasets: [
                      {
                        label: 'Kleine Strukturen',
                        backgroundColor: '#FFC002',
                        data: [_vm.klein[28].toteur / _vm.klein[28].eur.length]
                      },
                      {
                        label: 'Mittlere Strukturen',
                        backgroundColor: '#9BBB59',
                        data: [_vm.mittel[28].toteur / _vm.mittel[28].eur.length]
                      },
                      {
                        label: 'Grosse Strukturen',
                        backgroundColor: '#77933C',
                        data: [_vm.gross[28].toteur / _vm.gross[28].eur.length]
                      },
                      {
                        label: 'Durchschnitt',
                        backgroundColor: '#376092',
                        data: [((_vm.klein[28].toteur / _vm.klein[28].eur.length)+(_vm.mittel[28].toteur / _vm.mittel[28].eur.length)+(_vm.gross[28].toteur / _vm.gross[28].eur.length))/3]
                      }
                    ]
                  },"options":{responsive: true, maintainAspectRatio: false, legend: {display: true, position: 'right'}, plugins: { datalabels: { color: '#000', font: { weight: 'bold' }, anchor: 'end', align: 'end' }}, scales: { yAxes: [{ ticks: { beginAtZero:true, stepSize: 5 }}] }, title: { display: false, text: 'Personalkosten Küche für die Zubereitung von Lebensmitteln und den Abwasch in € pro Heimbewohner, pro Tag (Mittelwerte)', padding: 40 }}}}):_vm._e(),_vm._v(" "),(_vm.benchlang === 'it')?_c('stats',{attrs:{"chart-data":{
                    labels: [''],
                    datasets: [
                      {
                        label: 'Strutture piccole',
                        backgroundColor: '#FFC002',
                        data: [_vm.klein[28].toteur / _vm.klein[28].eur.length]
                      },
                      {
                        label: 'Strutture medie',
                        backgroundColor: '#9BBB59',
                        data: [_vm.mittel[28].toteur / _vm.mittel[28].eur.length]
                      },
                      {
                        label: 'Strutture grandi',
                        backgroundColor: '#77933C',
                        data: [_vm.gross[28].toteur / _vm.gross[28].eur.length]
                      },
                      {
                        label: 'Media',
                        backgroundColor: '#376092',
                        data: [((_vm.klein[28].toteur / _vm.klein[28].eur.length)+(_vm.mittel[28].toteur / _vm.mittel[28].eur.length)+(_vm.gross[28].toteur / _vm.gross[28].eur.length))/3]
                      }
                    ]
                  },"options":{responsive: true, maintainAspectRatio: false, legend: {display: true, position: 'right'}, plugins: { datalabels: { color: '#000', font: { weight: 'bold' }, anchor: 'end', align: 'end' }}, scales: { yAxes: [{ ticks: { beginAtZero:true, stepSize: 5 }}] }, title: { display: false, text: 'Costi per il personale di cucina per la preparazione degli alimenti e per la rigovernatura per residente in euro, al giorno (media)', padding: 40 }}}}):_vm._e(),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.content[15])}}),_vm._v(" "),_c('div',{staticClass:"spacer sm"})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3765355c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Print.vue
// module id = null
// module chunks = 